<template>
  <!-- A calm, factual notice that some figures follow a change only tonight
       (zone identity phase 6). Information, not a warning. -->
  <div class="change-notice" :class="{ compact }" role="note">
    <i class="bi bi-arrow-repeat" aria-hidden="true"></i>
    <div class="cn-body">
      <div class="cn-text">{{ text }}</div>
      <div v-if="detail" class="cn-detail">{{ detail }}</div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  text: { type: String, required: true },
  detail: { type: String, default: '' },
  compact: { type: Boolean, default: false },
})
</script>

<style scoped>
.change-notice {
  display: flex; gap: 10px; align-items: flex-start;
  background: #eef4fb; color: #2C5F86; border: 1px solid #d6e4f3;
  border-radius: 10px; padding: 12px 14px; margin: 12px 0;
}
.change-notice > i { font-size: 1.05rem; line-height: 1.35; }
.cn-text { font-weight: 600; font-size: .95rem; }
.cn-detail { font-size: .85rem; color: #4F7EB3; margin-top: 2px; }
.change-notice.compact { padding: 6px 10px; margin: 6px 0; font-size: .85rem; }
.change-notice.compact .cn-text { font-size: .85rem; }
</style>
